// NPM Modules
import React from 'react';
import PropTypes from 'prop-types';

// Styling
import './style.scss';

const loaderClass = grey => `loader ${grey || 'grey'}`;
const LoaderWrap = ({ grey }) => (
    <div className="loader-wrap">
        <div className={loaderClass(grey)} />
        <div className="mask" />
    </div>
);

const FakeLoader = ({ withMask, grey }) =>
    withMask ? <LoaderWrap grey /> : <div className={loaderClass(grey)} />;

FakeLoader.propTypes = {
    grey: PropTypes.bool,
    withMask: PropTypes.bool,
};

LoaderWrap.propTypes = {
    grey: PropTypes.bool,
};

export default FakeLoader;
